<template>
  <div>
    <el-dialog
      :visible.sync="tableVisible"
      :show-close="false"
      top="5vh"
      width="70%">
      <div class="flex justify-between items-center mb-2">
        <div class="text-lg font-bold">Alarm Notification List {{ locationAndSeverityLabel ? locationAndSeverityLabel : '' }}</div>
        <button v-if="isButtonMuteShow" class="bg-gray-600 text-white px-2 py-1 rounded" @click="isAlarmMute = !isAlarmMute">
          <i v-if="isAlarmMute" class="el-icon-close-notification"></i>
          <i v-else class="el-icon-bell"></i>
          {{ isAlarmMute ? 'Unmute' : 'Mute' }} Alarm Sound
        </button>
      </div>
      <vue-good-table
        :columns="tableColumns"
        :rows="notifications"
        styleClass="vgt-table bordered striped condensed"
        :pagination-options="{
          enabled: true,
          mode: 'records',
          perPage: 10
        }"
      >
        <template slot="table-row" slot-scope="props">
          <span :id="`${props.column.field}-${props.index}`" class="text-xs">
            {{ props.formattedRow[props.column.field] }}
          </span>
          <div
            v-if="props.column.field == 'action'"
            class="flex justify-around"
          > 
            <div 
              v-if="props.row.ModifiedDate" 
              class="bg-gray-400 text-white px-2 py-1 rounded flex justify-center items-center text-xs">
              Acknowledge
            </div>
            <div
              v-else
              class="bg-orange-600 text-white px-2 py-1 rounded flex justify-center items-center cursor-pointer text-xs"
              @click="confirmAcknowledgeAlarm(props.row.Id)">
              Acknowledge
            </div>
          </div>
        </template>
      </vue-good-table>
    </el-dialog>

    <!-- Acknowledge Confirmation Dialog -->
    <el-dialog
      title="Confirmation"
      :visible.sync="alarmAcknowledgeConfirmationDialogVisible"
      width="30%"
      center
      v-loading="alarmConfirmationDialogLoading"
    >
      <div class="text-center">
        Are you sure to acknowledge the notification?
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
          size="small"
          @click="alarmAcknowledgeConfirmationDialogVisible = false"
          >Cancel</el-button
        >
        <el-button size="small" type="primary" @click="acknowledgeAlarm()"
          >Confirm</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean
    },
    notifications: {
      type: Array
    },
    locationAndSeverityLabel: {
      type: String
    },
    doesSoundPlay: {
      type: Boolean,
      default: false
    },
    isButtonMuteShow: {
      type: Boolean,
      default: true
    }
  },  
  data() {
    return {
      tableVisible: false,
      // notifications: [],
      notificationSound: undefined,
      // alarmTableDialogVisible: false,
      alarmAcknowledgeConfirmationDialogVisible: false,
      alarmConfirmationDialogLoading: false,
      tableColumns: [
        {
          label: 'Id',
          field: 'Id',
          hidden: true
        },
        {
          label: 'Active Time',
          field: 'ActiveTime',
          type: 'date',
          dateInputFormat: 'yyyy-MM-dd hh:mm:ss',
          dateOutputFormat: 'dd-MMM-yyyy hh:mm:ss',
          filterOptions: {
            enabled: true,
            filterFn: this.columnFilterFn
          }
        },
        {
          label: 'Sensor Name',
          field: 'DceName',
          filterOptions: {
            enabled: true,
            filterFn: this.columnFilterFn
          }
        },
        {
          label: 'Description',
          field: 'Description',
          filterOptions: {
            enabled: true,
            filterFn: this.columnFilterFn
          }
        },
        {
          label: '',
          field: 'action',
          sortable: false,
          width: '120px'
        }
      ],
      alarmIdToAcknowledge: 0,
      isAlarmMute: false,
      alarmDialogHadBeenAwarn: false
    }
  },
  mounted() {
    this.$nextTick(function () {
      this.initNotificationSound()
    })

    setInterval(() => {
      try {
        this.playNotificationSound()
      } catch (err) {
        console.log('inimang err', err)
      }
    }, 2000)
  },
  watch: {
    visible: function (val) {
      this.tableVisible = val
    },
    doesSoundPlay: function (val) {
      this.isAlarmMute = !val
      this.playNotificationSound()
    },
    notifications: function () {
      this.playNotificationSound()
    },
    isAlarmMute: function (val) {
      if (val) this.notificationSound?.pause()

      setTimeout(() => {
        this.playNotificationSound()
      }, 500)
    }
  },
  methods: {
    async acknowledgeAlarm() {
      this.alarmConfirmationDialogLoading = true
      try {
        const alarm = this.notifications.find(
          (x) => x.Id === this.alarmIdToAcknowledge
        )

        await this.$axios.put(
          `Alarms/AcknowledgeAlarm?idalarm=${this.alarmIdToAcknowledge}`
        )

        // Remove alarm from notification table list
        const indexOfItem = this.notifications.indexOf(alarm)
        this.notifications.splice(indexOfItem, 1)
      } catch (err) {
        console.log(err)
        this.$message.error("There's something wrong, please try again.")
        this.alarmAcknowledgeConfirmationDialogVisible = false
        this.alarmConfirmationDialogLoading = false
      }
      this.alarmAcknowledgeConfirmationDialogVisible = false
      this.alarmConfirmationDialogLoading = false
    },
    initNotificationSound() {
      const audioSource = require('@/assets/sounds/notification-sound.mp3')
      const notificationSound = new Audio(audioSource)
      notificationSound.loop = true
      this.notificationSound = notificationSound
    },
    playNotificationSound() {
      if (this.notifications.length > 0) {
        if (!this.isAlarmMute) this.notificationSound?.play()
      } else {
        this.notificationSound?.pause()
      }
    },
    confirmAcknowledgeAlarm(alarmId) {
      this.alarmIdToAcknowledge = alarmId
      this.alarmAcknowledgeConfirmationDialogVisible = true
    }
  }
}
</script>